"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_TYPE_ICONS = exports.DEFAULT_BACKGROUND = void 0;
const IMAGE_TYPE_ICONS = exports.IMAGE_TYPE_ICONS = {
  '': '',
  FLIGHT: 'FlightIcon',
  HOTEL: 'HotelIcon',
  COMMUNITIES: 'PeopleIcon',
  DEALS: 'WhatshotIcon',
  ACTIVITIES: 'BeachAccessIcon',
  LOCATION: 'LocationOnIcon',
  CHEVRON_RIGHT: 'ChevronRightIcon',
  CHEVRON_LEFT: 'ChevronLeftIcon',
  VISIBILITY: 'VisibilityIcon',
  VISIBILITY_OFF: 'VisibilityOffIcon',
  AMEX_LOGO: 'AmexLogo',
  VISA_LOGO: 'VisaLogo',
  JCB_LOGO: 'JcbLogo',
  UNION_PAY_LOGO: 'UnionPayLogo',
  BIG_PAY_LOGO: 'BigPayLogo',
  MASTER_CARD_LOGO: 'MasterCardLogo'
};
const DEFAULT_BACKGROUND = exports.DEFAULT_BACKGROUND = 'tertiary';